<template>
  <div>
    <div style="margin-bottom: 20px; text-align: left;display: flex;align-items:center">
      <div>
        <el-button size="small" type="danger" @click="addTab(editableTabsValue)"> 新增 </el-button>
      </div>
<!--      <div style="width: 90%;margin: 0 auto;color: red">-->
<!--        Academic referees should have taught you during your university-level studies,preferably in relevant courses, at your current or most recent institution(s). They-->
<!--        should know your academic work well and be able to comment in detall on youracademic performance and ability, skills and qualities, and motivation and suitabilityrelevant to the programme(s) you are applying for-->
<!--        Professional reteree should normally be your line manager/supervisor from your current or most recentemployment. They should know your work well and be able to comment in detail onyour ability, skills and qualities,-->
<!--        and motivation and suitability, relevant to theprogramme(s)you are applying for.-->
<!--      </div>-->
    </div>
    <el-alert
    title="硕士申请至少两位（英美 top 学校需要三位），博士申请至少三位"
    type="warning">
  </el-alert>
    <el-tabs v-model="editableTabsValue" type="card" closable @tab-remove="removeTab" :before-leave="beforeLeave">
      <el-tab-pane label="首页" name="first">
        <el-card>
          <div>
            <span style="font-size: 22px;color: red">Academic referees</span> should have taught you during your university-level studies,preferably in relevant courses, at your current or most recent institution(s). They should know your academic work well and be able to comment in detall on your academic performance and ability, skills and qualities, and motivation and suitability relevant to the programme(s) you are applying for
            <p style="font-size: 16px"><b>在读学生或毕业年份较短的同学推荐寻找两位学术推荐人，学术推荐人应该在你的大学学习期间，最好是在你目前或最近的机构的相关课程中教过你。他们应该很好地了解你的学术工作，并能够详细评论你的学术表现和能力、技能和素质，以及与你申请的课程相关的动机和适合性</b></p>
          </div>
          <div>
            <span style="font-size: 22px;color: red">Professional referees</span> should normally be your line manager/supervisor from your current or most recent employment. They should know your work well and be able to comment in detail onyour ability, skills and qualities,and motivation and suitability, relevant to theprogramme(s)you are applying for.
            <p style="font-size: 16px"><b>工作达到5-7年的同学可以寻找职业推荐人。职业推荐人通常应该是您当前或最近工作的直线经理/主管。他们应该非常了解你的工作，能够详细评论你的能力、技能和品质，以及与你申请的课程相关的动机和适合性。</b></p>
          </div>
        </el-card>
        <el-image :src="img"></el-image>
      </el-tab-pane>
      <el-tab-pane v-for="(item, i) in editableTabs" :key="item.name" :name="item.name">
        <span slot="label"> {{ item.title }}{{ i + 1 }} </span>
        <tab_referrer
          :user_profile_checklist="item.checkList"
          :user_profile_referrer="item.referrer"
          :ref="'son_' + i"
        ></tab_referrer>
      </el-tab-pane>
    </el-tabs>
    <HBFixedButton v-if="editableTabsValue != 'first'" v-loading.fullscreen.lock="from_loading" @click="submitProfile" :desc="infoStatusDesc(study_abroad_information_status)"/>
  </div>
</template>
<script>
import tab_referrer from "./tab_referrer.vue";
import {profile_update_two, student_profile} from "@/api/mycenter_studyabroad";
import HBRadioGroupDialog
  from "../HBCommon/HBRadioGroupDialog/HBRadioGroupDialog";
import HBFixedButton from "../HBCommon/HBFixedButton/HBFixedButton";
import {infoStatusDesc} from '../HBCommon/util'
import { kCacheAbroadInfos } from '../tool';
export default {
  name: "TabSix",
  components: {
    HBRadioGroupDialog,
    tab_referrer,
    HBFixedButton,
  },
  props: {
    user_profile: {
      default: "",
    },
  },
  watch: {
    user_profile: {
      handler(val, oldVal) {
        if (val) {
          val.forEach((item, index) => {
            item.name = index.toString()
          })
          this.editableTabs = val
        }
      },
      immediate: true,
      deep: true,
    },
  },
  data() {
    return {
      study_abroad_information_status: 0,
      radioGroupDialogFlag: false,
      radioGroupDialogDatasource: [],
      from_loading: false,
      img:
        "https://ielts-refactor.oss-cn-chengdu.aliyuncs.com/web_file/D413546029213122.jpg",
      first_profile: {},
      second_profile: {},
      third_profile: {},
      profile: {},
      editableTabsValue: "first",
      editableTabs: [
        {
          title: "推荐人 ",
          name: "1",
          checkList: "",
          referrer: "",
        },
      ],
      checkAssemblyData: true,
      rl_info_str: '',
      tabIndex: 1,
      index: 0
    };
  },
  created() {
    this.studentProfile(this.$route.query.userId)
  },
  methods: {
    infoStatusDesc(type) {
      return infoStatusDesc(type)
    },
    radioGroupDialogCallback(val) {
      this.submitData(val)
    },
    assemblyData() {
      return JSON.stringify(this.editableTabs)
    },
    beforeLeave(activeName, oldActiveName) {
      return this.checkContentModified(activeName)
    },
    checkContentModified(activeName) {
      const that = this
      // this.checkAssemblyData不等于true代表的是这是自己新增推荐人更新的字符串，不是修改数据更新的字符串，不需要进行新老字符串对比
      if (this.checkAssemblyData) {
        if (this.rl_info_str && (JSON.stringify(JSON.parse(this.rl_info_str),true) !== this.assemblyData())) {
          this.$message({
            message: '请先保存当前内容',
            type: 'error'
          })
          return false
        }
      }
      // this.editableTabs.forEach((item, index) => {
      //   if (item.name == activeName) {
      //     that.study_abroad_information_status = item.StudyAbroadInformationStatus
      //   }
      // })
      this.checkAssemblyData = true
    },
    checkStrNull(_redata){
      var status = true
      _redata.forEach((item, index) => {
        // if(item.referrer.is_institution_write == 1){
          if (!item.referrer.personal_name || !item.referrer.surname) {
            this.$message({
              message: "请完善推荐人姓名",
              type: "error",
            });
            status = false;
          }
        // }
        if (!item.referrer.is_institution_write) {
          this.$message({
            message: "请选择推荐人是否自己写RL",
            type: "error",
          });
          status = false;
        }
      })
      return status
    },
    studentProfile(user_id) {
      student_profile({ 'user_id': user_id })
        .then(response => {
          this.rl_info_str = response.data.rl_info
          var rl_info = JSON.parse(response.data.rl_info)
          var that = this
          rl_info.forEach((item, index) => {
            if (item.name > that.index) {
              that.tabIndex = item.name
            }
            // warning:把状态存在推荐人中的 每个推荐人状态都是一样的
            that.study_abroad_information_status = item.StudyAbroadInformationStatus;
          })
          this.editableTabs = rl_info
        })
        .catch(error => {
          console.log(error)
        })
    },
    addTab(targetName) {
      if (this.checkContentModified() == false ) {
        return
      }
      if (this.checkStrNull(JSON.parse(this.rl_info_str)) == false ) {
        return
      }
      var that = this
      that.checkAssemblyData = false
      var newTabName = ++this.tabIndex + ''
      this.editableTabs.push(this.returnStr(newTabName))
      that.rl_info_str = JSON.stringify(this.editableTabs,true)
      that.editableTabsValue = newTabName
    },
    returnStr(newTabName) {
      return {
        title: '推荐人 ',
        name: newTabName,
        referrer: {
          is_institution_write:'',
          checkList:[],
          surname:'',
          personal_name:'',
          email:'',
          contact_information:'',
          address:'',
          position:'',
          corporate_name:'',
          sex:'',
          con_1:'',
          con_2:'',
          con_3:'',
          con_4:'',
          con_5:'',
          con_6:'',
          con_7:'',
          con_8:'',
          con_9:'',
          con_10:'',
          con_11:''
        },
        checkList: [],
        StudyAbroadInformationStatus: 0,
      }
    },
    removeTab(targetName) {
      this.$confirm('是否确认删除该推荐人？').then(()=> {
        var tabs = this.editableTabs
        var that = this
        var activeName = this.editableTabsValue
        if (activeName === targetName) {
          tabs.forEach((tab, index) => {
            if (tab.name === targetName) {
              var nextTab = tabs[index + 1] || tabs[index - 1]
              if (nextTab) {
                activeName = nextTab.name
              }
            }
          })
        }
        if (tabs.length == 1) {
          this.editableTabsValue = "first"
        } else {
          this.editableTabsValue = activeName
        }
        that.rl_info_str = JSON.parse(that.rl_info_str)
        that.rl_info_str.forEach(function(item, index) {
          if (item.name == targetName) {
            that.rl_info_str.splice(index, 1)
          }
        })
        that.rl_info_str = JSON.stringify(this.rl_info_str)
        this.editableTabs = tabs.filter((tab) => tab.name !== targetName)
      })
    },
    // 提交数据
    submitProfile() {
      if (this.checkStrNull(this.editableTabs) == false ) {
        return
      }
      this.$confirm("是否确认保存？", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          this.submitData(this.study_abroad_information_status)
        })
        .catch(() => {});

    },
    submitData(val) {
      var _rl_info = this.assemblyData()
      if (!_rl_info) {
        return
      }
      var urserid = parseInt(this.$route.query.userId)
      this.from_loading = true
      const rData = { 'rl_info': _rl_info,'activeRoute':this.editableTabsValue,'activeRouteValue':val,'user_id': urserid }
      kCacheAbroadInfos(JSON.stringify(rData))
      profile_update_two(rData)
        .then((response) => {
          this.from_loading = false
          if (response.code === 200) {
            this.$message({
              message: "保存成功",
              type: "success",
            });

          }
          this.studentProfile(urserid)
        })
        .catch((error) => {
          this.from_loading = false
          this.$message({message:error.message,type:'error'})
        });
    },
  },
};
</script>
<style scoped lang="scss">
.submit-file {
  width: 8.375rem;
  height: 2.6875rem;
  background: linear-gradient(89deg, #fdcf00 0%, #fdb100 100%);
  opacity: 1;
  border-radius: 1.3125rem;
  margin-bottom: 2.6875rem;
}
</style>



// WEBPACK FOOTER //
// src/components/mycenter_studyabroad/component/tab_six.vue